import { render } from "./CreateNoteModal.vue?vue&type=template&id=612fd37e&ts=true"
import script from "./CreateNoteModal.vue?vue&type=script&lang=ts"
export * from "./CreateNoteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__